import React from 'react'

import { Portlet, Col, Row, Form, Divider, Table } from '_zari/core'

const MainCard = ({ estadoCuentaInfo, portletBreadcrumbs }) => {
  return (
    <>
      <Portlet>
        <Portlet.Header title='Compras' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label text='RUC' md={4} />
                <Col md={8}>
                  <Form.InputText defaultValue={estadoCuentaInfo.numeroDocumentoSocio} disabled />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='RAZON SOCIAL' md={4} />
                <Col md={8}>
                  <Form.InputText defaultValue={estadoCuentaInfo.nombreSocio} disabled />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='DOCUMENTO' md={4} />
                <Col md={8}>
                  <Form.InputText
                    defaultValue={`${estadoCuentaInfo.serieDocumento} - ${estadoCuentaInfo.numeroDocumento}`}
                    disabled
                  />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='FEC. EMISION' md={4} />
                <Col md={8}>
                  <Form.InputText defaultValue={estadoCuentaInfo.fechaEmision} disabled />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='FEC. VENCIMIENTO' md={4} />
                <Col md={8}>
                  <Form.InputText defaultValue={estadoCuentaInfo.fechaVencimiento} disabled />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='IMPORTE' md={4} />
                <Col md={8}>
                  <Form.InputText defaultValue={estadoCuentaInfo.importe} disabled />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Divider title='PAGOS' />
          <Table.ClientSide
            headRows={[{ label: 'FECHA' }, { label: 'CUENTA' }, { label: 'MONTO' }, { label: 'MONEDA' }]}
            filas={estadoCuentaInfo.pagos}
            rowTemplate={(row, k) => (
              <Table.Row hover key={k}>
                <Table.Cell>{row.fecha || '--'}</Table.Cell>
                <Table.Cell>{row.cuentaContable || '--'}</Table.Cell>
                <Table.Cell>{row.importePago || '--'}</Table.Cell>
                <Table.Cell>{row.moneda || '--'}</Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default MainCard
